import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/AdminActions";
import {loadAdminJobs} from "../helper functions/LoadAdminJobs";

export default function EnquiryApprovedList() {

    const dispatch = useDispatch()
    let sort = useSelector(state => state.adminSortComplete);
    let search = useSelector(state => state.adminSearchComplete);

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>

                <div className="page-title-sh26">
                    <h1>Approved Admin jobs</h1>
                    <p> These are enquiries that have been approved </p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => {
                            dispatch(actions.SortNew("APPROVED"))
                        }}>Newest First </a>
                        <a onClick={sort => dispatch(actions.SortOld("APPROVED"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("APPROVED"))}> A-Z </a>
                    </div>
                </div>

                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.completeSearch(document.getElementById("search-input").value, "UNAPPROVED"))}> 🔍
                    </button>
                </div>

                <div className="page-break"></div>
                <br/>

                <div>
                    {loadAdminJobs(sort, search)}
                </div>

                <div className="page-break"></div>

            </AuthenticatedTemplate>
        </div>
    );
}
